import segment from 'src/js/modules/analytics/segment';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackElementSettingsControlClicked = ({
  blockId,
  blockVariationId,
  settingId,
  tabId,
  elementType,
  controlId,
}) => {
  if (!blockId || !controlId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_OPTION_CLICKED, {
    blockId,
    blockVariationId,
    settingId,
    tabId,
    elementId: elementType,
    optionId: controlId,
  });
};

export default trackElementSettingsControlClicked;
